import type { NotificationCategory, NotificationItem, Pagination, UnreadCount } from './type';
import { agentsRequest } from '@/services/request';

const BASE = '/notifications/v1';
const SILENT_NOTIFICATION_REQUEST_CONFIG = {
  hideCodeErrorMessage: true,
  hideHTTPErrorMessage: true,
};

/** 通知列表 */
export function fetchNotifications(params: { page?: number; pageSize?: number; category?: NotificationCategory }) {
  return agentsRequest.get<{ list: NotificationItem[]; pagination: Pagination }>(BASE, {
    ...SILENT_NOTIFICATION_REQUEST_CONFIG,
    params,
  });
}

/** 未读数（含分类计数） */
export function fetchUnreadCount() {
  return agentsRequest.get<UnreadCount>(`${BASE}/unread-count`, SILENT_NOTIFICATION_REQUEST_CONFIG);
}

/** 标记单条已读 */
export function markAsRead(id: string) {
  return agentsRequest.put(`${BASE}/${id}/read`);
}

/** 全部已读 */
export function markAllAsRead() {
  return agentsRequest.put(`${BASE}/read-all`);
}
